import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { faGripDotsVertical } from '@fortawesome/pro-regular-svg-icons/faGripDotsVertical';
import clsx from 'clsx';
import { DraggingModuleContext } from 'src/modules/contentList/contexts/draggingModuleContext';
import { DraggingPageContext } from 'src/modules/contentList/contexts/draggingPageContext';
import { useIsReorderingContent } from 'src/modules/contentList/hooks/useIsReorderingContent';
import { Icon } from 'src/shared/components/icon';
export function DragHandle(props) {
    const isReorderingContent = useIsReorderingContent();
    const { draggingModuleId } = useContext(DraggingModuleContext);
    const { draggingPageId } = useContext(DraggingPageContext);
    const isDragging = draggingModuleId || draggingPageId;
    return (
    // @formkit/drag-and-drop handle does not work with button
    _jsx("div", { className: clsx({
            'cursor-not-allowed': isReorderingContent
        }), children: _jsx("div", { className: clsx('!cursor-grab rounded-medium border border-neutral-0 px-4 py-2 text-neutral-900 transition-all duration-500 [transition-timing-function:cubic-bezier(0.2,1,0.2,1)] hover:bg-neutral-200', {
                'pointer-events-none': isReorderingContent,
                '!bg-neutral-0': isDragging,
                'active:border-neutral-400': !isDragging
            }), ...props, role: "button", children: _jsx(Icon, { icon: faGripDotsVertical }) }) }));
}
